module.exports = __webpack_public_path__ + "media/images/page/occupation_ic-2fb970e9827b703cbccf442a502d8518.svg";